/**
 * DB以外で定義しているコード値をまとめるEnum
 * @constructor
 */

export class AppCodeInfo {
  readonly key: string;
  readonly value: number;
  constructor(key: string, value: number) {
    this.key = key;
    this.value = value;
  }
}

export const appEnums = Object.freeze({
  yomokkaOption: {
    readableAll: new AppCodeInfo('読み放題 (朝日小学生新聞含む）', 1),
    isNoAsahiReading: new AppCodeInfo('読み放題 (朝日小学生新聞含まない)', 4),
    whitelist: new AppCodeInfo('ホワイトリスト', 2),
    nextGiga: new AppCodeInfo('Lenovo Ed.', 3),
  },
  // Idp種別(googole、microsoftは画面表示のため入れ替え)
  idpType: {
    google: new AppCodeInfo('Google', 2),
    microsoft: new AppCodeInfo('Microsoft', 1),
  },
});

export default appEnums;
